import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { Button } from './Button';
interface HeaderProps {
  onBookClick: () => void;
}
export function Header({
  onBookClick
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-175">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-176">
        <a href="#" className="relative z-10 flex items-center gap-3" data-id="element-177">
          <img src="https://cdn.magicpatterns.com/uploads/5ehSxxLNge9mVEnk9GFcym/Glitzz_by_Shazz_Logo.png" alt="Glitzz by Shazz Logo" className={`h-12 md:h-16 w-auto object-contain transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`} data-id="element-178" />
        </a>

        <div className="flex items-center gap-6" data-id="element-179">
          <a href="tel:+16463974299" className={`hidden md:flex items-center gap-2 font-medium transition-colors ${isScrolled ? 'text-brand-dark hover:text-brand-purple' : 'text-white hover:text-brand-gold'}`} data-id="element-180">
            <Phone className="w-4 h-4" data-id="element-181" />
            (646) 397-4299
          </a>
          <Button onClick={onBookClick} variant={isScrolled ? 'primary' : 'secondary'} size="sm" className="md:px-6 md:py-3" data-id="element-182">
            Book Now
          </Button>
        </div>
      </div>
    </motion.header>;
}